import {
    modelServices
} from '@/app/shared/services/client-agent-service.js';
import {
    httpClient
} from '@/app/shared/services/http-client/http-client.js';

export class DispensingHistoryService {
    
    constructor() {
       
        this.GetDispenseHistory = modelServices.baseUrl + modelServices.getPharmacyServiceName("GetDispsenseHistory").URL;
        this.VisitReceipts = modelServices.baseUrl + modelServices.getPharmacyServiceName("VisitReceiptsOData").URL;
    }


    InitFiltrationCriteriaLookUpsByClassification(schemaTypeID, visitClassificationId, callback, errCallback) {

        var url = `${modelServices.baseUrl}${modelServices.getPharmacyServiceName("InitFiltrationCriteriaLookUpsByClassification").URL}?visitClassification=${visitClassificationId}&schemaTypeID=${schemaTypeID}`;

        httpClient.get(url).then(callback).catch(errCallback);
    }

    FilterClinicsData(startDateTime, endDateTime, callback, errCallback) {

        var url = `${modelServices.baseUrl}${modelServices.getPharmacyServiceName("FilterClinicsData").URL}?startDateTime=${encodeURIComponent(new Date(startDateTime).toISOString())}&endDateTime=${encodeURIComponent(new Date(endDateTime).toISOString())}`;

        httpClient.get(url).then(callback).catch(errCallback);
    }
    GetBarcodeDetail(barcode, callback, errCallback) {
        var url = `${modelServices.baseUrl}${modelServices.getPharmacyServiceName("GetBarcodeDetail").URL}?barcode=${barcode}`;
        httpClient.get(url).then(callback).catch(errCallback);

    }

    InitFiltrationCriteriaLookUpsReturnByReciept(callback, errCallback) {

        var url = `${modelServices.baseUrl}${modelServices.getPharmacyServiceName("InitReturnByReceiptSearch").URL}`;

        httpClient.get(url).then(callback).catch(errCallback);
    }

    GetByOrderVisitCreationTypeConfiguration(callback, errCallback) {

        var url = `${modelServices.baseUrl}${modelServices.getPharmacyServiceName("GetByOrderVisitCreationTypeConfiguration").URL}`;

        httpClient.get(url).then(callback).catch(errCallback);
    }

    GetProductDetailsByBarcodeSC(barcode, callback, errCallback) {
        var url = `${modelServices.baseUrl}${modelServices.getPharmacyServiceName("GetProductDetailsByBarcode").URL}?barcode=${barcode}`;
        httpClient.get(url).then(callback).catch(errCallback);

    }
}


const dispensingHistoryService = new DispensingHistoryService();

export { dispensingHistoryService };